<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title" matTooltip="{{ data?.action | titlecase }} Node Group (also called partition or queue)">{{ data?.action | titlecase }} Node Group</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body" *ngIf="isCreate" style="max-height: 50vh; width: 100%; overflow-y: auto; overflow-x: hidden;">
    <div style="height:32vh; width: 100%; overflow-y: auto; overflow-x: hidden;">
      <form name="updateNodeGroup"
            [formGroup]="updateNodeGroup"
            autocomplete="off"
            spellcheck="false">

        <mat-form-field style="width: 100%">
          <mat-label>Node group (partition or queue) name</mat-label>
          <input matInput
                maxlength="36"
                placeholder="Node group (partition or queue) name"
                formControlName="nodeGroupName"
                matTooltip="Add a unique identifier. Only alphabets, numbers, '_', '-' allowed" />
          <mat-error *ngIf="updateNodeGroup.get('nodeGroupName').invalid">Entered name is not Valid.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" style="width: 100%; margin-top: 2%" matTooltip="Select compute nodes" matTooltipPosition="above">
          <mat-select formControlName ="nodes" placeholder="Select compute nodes" [multiple]="true" #multiSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="multiFilterCtrl" placeholderLabel="Search by name..." 
              noEntriesFoundLabel="'no match found'"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let vm of filteredComputeNodes" [value]="vm">
              {{vm}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="updateNodeGroup.get('nodes').touched && updateNodeGroup.get('nodes').errors">
            Please {{ selectNodeMatLabel }}.
          </mat-error>
        </mat-form-field>

        <div *ngIf="updateNodeGroup.get('nodes').value && updateNodeGroup.get('nodes')?.value?.length > 0" class="selected-items">
          <h4 style="font-size: 14px;">Selected nodes/workstations</h4>
          <div class="selected-list">
            <div *ngFor="let vm of updateNodeGroup.get('nodes').value" class="selected-item">
              <span>{{ vm }}</span>
            </div>
          </div>
        </div>
      </form>
      <div style="margin-top:2%" class="dialog-container" *ngIf="setAdditionalProperties">
          <select class="custom-select" [(ngModel)]="selectedProperty">
            <option *ngFor="let key of dictionaryKeys" [value]="key" [attr.title]="getOptionTitle(key)">{{ key }}</option>
          </select>
          <input class="custom-input" [(ngModel)]="dictionary[selectedProperty]" placeholder="Value" (input)="updateDictionary()">
        </div>

        <div style="margin-top:2%" *ngIf="showAdditionalSettings">
          <input type="checkbox" title="Select Process"
                class="selectCheckbox"
                (click)="checkSelectedCheckboxes($event)"
                [checked]="setAdditionalProperties">
          <span style="margin-left:1%">Set additional Properties</span>
        </div>
    </div>
  </div>

  <div class="modal-body" *ngIf="isUpdate" style="max-height: 50vh; width: 100%; overflow-y: auto; overflow-x: hidden;">
    <div style="height:32vh; width: 100%; overflow-y: auto; overflow-x: hidden;">
      <form name="updateNodeGroup"
          [formGroup]="updateNodeGroup"
          autocomplete="off"
          spellcheck="false">

      <div>
        <ng-select appearance="outline" appendTo="body" labelForId="Node Group" [searchable]="true" formControlName="nodeGroupName" placeholder="Select Node Group">
          <ng-option *ngFor="let group of existingNodeGroupsList" [value]="group">{{ group }}</ng-option>
        </ng-select>

        <!-- <div class="mt-2">
          <ng-select appearance="outline" [items]="computeNodeObj" bindLabel="name" bindValue="name" appendTo="body" labelForId="Partition" [searchable]="true" formControlName="nodes" [closeOnSelect]="false" placeholder="Select compute nodes" [multiple]="true" createNodeGroup>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name | uppercase}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
            </ng-template>
          </ng-select>
          <mat-error *ngIf="
            updateNodeGroup.get('nodes').touched &&
            updateNodeGroup.get('nodes').errors
          ">Please Select compute nodes.</mat-error>
        </div> -->

        <mat-form-field appearance="fill" style="width: 100%; margin-top: 2%;" matTooltip="Select compute nodes" matTooltipPosition="above">
          <mat-select formControlName ="nodes" placeholder="Select compute nodes" [multiple]="true" #multiSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="multiFilterCtrl" placeholderLabel="Search by name..." 
              noEntriesFoundLabel="'no match found'"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let vm of getComputeNodesForPartition()" [value]="vm">
              {{vm}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="updateNodeGroup.get('nodes').touched && updateNodeGroup.get('nodes').errors">
            Please {{ selectNodeMatLabel }}.
          </mat-error>
        </mat-form-field>

        <div *ngIf="updateNodeGroup.get('nodes').value && updateNodeGroup.get('nodes')?.value?.length > 0" class="selected-items">
          <h4 style="font-size: 14px;">Selected nodes/workstations</h4>
          <div class="selected-list">
            <div *ngFor="let vm of updateNodeGroup.get('nodes').value" class="selected-item">
              <span>{{ vm }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div style="margin-top:2%" class="dialog-container" *ngIf="setAdditionalProperties">
          <select class="custom-select" [(ngModel)]="selectedProperty">
            <option *ngFor="let key of dictionaryKeys" [value]="key" [attr.title]="getOptionTitle(key)">{{ key }}</option>
          </select>
          <input class="custom-input" [(ngModel)]="dictionary[selectedProperty]" placeholder="Value" (input)="updateDictionary()">
        </div>

        <div style="margin-top:2%" *ngIf="showAdditionalSettings">
          <input type="checkbox" title="Select Process"
                class="selectCheckbox"
                (click)="checkSelectedCheckboxes($event)"
                [checked]="setAdditionalProperties">
          <span style="margin-left:1%">Set additional Properties</span>
        </div>
    </div>
    
    
  </div>

  <div class="modal-body" *ngIf="isDelete">
    <div>
      <form name="deleteNodeGroup"
            [formGroup]="deleteNodeGroup"
            autocomplete="off"
            spellcheck="false">
        <mat-form-field appearance="fill" style="width: 100%;" matTooltip="Select node group (also called partition or queue)" matTooltipPosition="above">
          <mat-label style="font-size:small">Select node group (also called partition or queue)</mat-label>
          <mat-select formControlName="nodeGroupName" [(ngModel)]="nodeGroupSelectedToDelete">
            <mat-option *ngFor="let nodegroup of existingNodeGroupsList" [value]="nodegroup">
              {{ nodegroup }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="
          deleteNodeGroup.get('nodeGroupName').touched &&
          deleteNodeGroup.get('nodeGroupName').errors
        ">Please select node group to delete.</mat-error>
        </mat-form-field>
        <br />
        <p *ngIf="isDelete == true" style="margin-top: 5%">Please type name of node group (also called partition or queue) to confirm.</p>
        <input *ngIf="isDelete == true"
               type="text"
               formControlName="confirmText"
               spellcheck="false"
               class="confirmInput"
               [(ngModel)]="nodeGroupSelectedToDeleteText" />
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="onCancel()">Cancel</button>
    <button *ngIf="isCreate" type="button" class="btn btn-primary" (click)="onSubmit(updateNodeGroup)" [disabled]="disableSubmit">Create</button>
    <button *ngIf="isUpdate" type="button" class="btn btn-primary" (click)="onSubmit(updateNodeGroup)" [disabled]="disableSubmit">Update</button>
    <button *ngIf="isDelete" type="button" class="btn btn-danger" [disabled]="deleteNodeGroup.get('confirmText').value != deleteNodeGroup.get('nodeGroupName').value || disableSubmit" (click)="onSubmit(deleteNodeGroup)">Delete</button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
    size="default" zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="updateCredential"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
